// extracted by mini-css-extract-plugin
export default {"btn":"Button-module__btn--_aF7k"};